import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const Services = () => {

  const services = [
    {
      title: "Title Services",
      description:
        "Title Services designed to ensure the security and validity of property transactions in the Title industry.",
      items: [
        "Order Entry",
        "Current Owner Search",
        "2 Owner Search",
        "Full Search",
        "Document Retrievals",
      ],
      link: "/title-services",
      image:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80&auto=format&fit=crop",
      imageAlt: "Title Services - Property documents",
      gradientFrom: "from-blue-600",
      gradientTo: "to-blue-800",
      badgeBg: "bg-blue-100",
      badgeText: "text-blue-700",
      checkColor: "text-blue-500",
    },
     {
      title: "Title Commitment & Package",
      description:
        "A structured back-office solution supporting U.S. title agencies, underwriters, and settlement teams with precision and compliance.",
      items: [
        "Title Package Preparation",
        "Document Typing & Data Entry",
        "Chain of Title Review",
        "Lien & Encumbrance Review",
        "Quality Control & Final Review"
      ],
      link: "/title-commitment-services",
      image:
        "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80&auto=format&fit=crop",
      imageAlt: "Title Commitment Services - Legal file preparation",
      gradientFrom: "from-red-600",
      gradientTo: "to-rose-800",
      badgeBg: "bg-red-100",
      badgeText: "text-red-700",
      checkColor: "text-red-500",
    },
    {
      title: "Curative Services",
      description:
        "Designed to resolve title defects and ensure the smooth transfer of real estate properties.",
      items: [
        "Payoff Ordering",
        "HOA Estoppels",
        "HOA Dues Status",
        "Municipal Lien Searches",
        "Release Tracking",
      ],
      link: "/curative-services",
      image:
        "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&q=80&auto=format&fit=crop",
      imageAlt: "Curative Services - Legal documents",
      gradientFrom: "from-emerald-600",
      gradientTo: "to-emerald-800",
      badgeBg: "bg-emerald-100",
      badgeText: "text-emerald-700",
      checkColor: "text-emerald-500",
    },
    {
      title: "Settlement Services",
      description:
        "We offer Settlement Services to facilitate smooth and successful real estate transactions.",
      items: [
        "CD Preparation",
        "Pre-CD Preparation",
        "Notary Scheduling",
        "Post Closing Audit",
        "Policy Typing",
      ],
      link: "/settlement-services",
      image:
        "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80&auto=format&fit=crop",
      imageAlt: "Settlement Services - Signing documents",
      gradientFrom: "from-violet-600",
      gradientTo: "to-violet-800",
      badgeBg: "bg-violet-100",
      badgeText: "text-violet-700",
      checkColor: "text-violet-500",
    },
    {
      title: "Tax Services",
      description:
        "Tax Services tailored to meet the diverse needs of our clients in the real estate and mortgage industries.",
      items: [
        "Tax Certificate",
        "PA & NY Tax Searches",
        "Escrow Tax Services",
        "Delinquency Search",
        "Tax Updates",
      ],
      link: "/tax-services",
      image:
        "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80&auto=format&fit=crop",
      imageAlt: "Tax Services - Financial planning",
      gradientFrom: "from-amber-600",
      gradientTo: "to-amber-800",
      badgeBg: "bg-amber-100",
      badgeText: "text-amber-700",
      checkColor: "text-amber-500",
    },
  ];


  return (
    <div className="bg-white">
      <Helmet>
        <meta charSet="utf-8" />
        <title>CityPulse LLC | Our Services</title>
        <link rel="canonical" href="https://citypulsellc.com/services" />
      </Helmet>

      {/* <section className="relative bg-gradient-to-r from-primary to-primary-dark text-white py-20 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')`
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary/95 to-primary-dark/95"></div>
        <div className="absolute inset-0 bg-grid"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="glass-card rounded-2xl p-8 md:p-12 inline-block">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 text-primary">Our Services</h1>
            <p className="text-xl text-gray-700 max-w-3xl font-semibold">
              Comprehensive Title and Settlement Services solutions designed to support
              the mortgage industry with precision and reliability.
            </p>
          </div>
        </div>
      </section> */}

      <section className="relative min-h-[60vh] flex flex-col justify-center overflow-hidden bg-gray-950">

        {/* Background photo */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')`
          }}
        />
        {/* Layered overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-gray-950/85 via-gray-900/70 to-blue-900/50" />

        {/* Decorative blobs + dot grid */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-blue-500/20 blur-3xl" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-indigo-500/10 blur-3xl" />
          <div
            className="absolute inset-0 opacity-10"
            style={{
              backgroundImage: `radial-gradient(circle, #fff 1px, transparent 1px)`,
              backgroundSize: `32px 32px`,
            }}
          />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">

          {/* Eyebrow badge */}
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-blue-300">
              <span className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
              City Pulse LLC
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-white leading-none mb-6 max-w-3xl">
            Our
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-300 mt-1">
              Services
            </span>
          </h1>

          {/* Accent divider */}
          <div className="flex items-center gap-4 mb-6">
            <div className="h-px w-16 bg-gradient-to-r from-blue-400 to-transparent" />
            <div className="w-2 h-2 rounded-full bg-blue-400" />
          </div>

          {/* Description */}
          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl leading-relaxed mb-10">
            Comprehensive Title and Settlement Services solutions designed to support
            the mortgage industry with precision and reliability.
          </p>

          {/* Service category pills */}
          <div className="flex flex-wrap gap-3">
            {["Title Services", "Curative Services", "Settlement Services", "Tax Services"].map((label) => (
              <span
                key={label}
                className="inline-flex items-center gap-2 bg-white/10 border border-white/15 backdrop-blur-sm rounded-full px-4 py-2 text-sm text-gray-300"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-blue-400" />
                {label}
              </span>
            ))}
          </div>
        </div>
      </section>


      {/* Header */}
      <section className="relative py-24 bg-gray-50 overflow-hidden">
        {/* Background decorations */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-blue-50 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-60 pointer-events-none" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-violet-50 rounded-full translate-x-1/2 translate-y-1/2 opacity-60 pointer-events-none" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* Section Header */}
          <div className="text-center mb-20">
            <span className="inline-block text-sm font-semibold tracking-widest uppercase text-blue-600 mb-3">
              What We Offer
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 leading-tight">
              Our Core Services
            </h2>
            <div className="w-16 h-1 bg-blue-600 rounded-full mx-auto mb-6" />
            <p className="text-xl text-gray-500 max-w-3xl mx-auto leading-relaxed">
              Comprehensive Title, Curative, Settlement, and Tax Services designed to
              support secure and compliant real estate transactions.
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <div
                key={service.title}
                className="group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 border border-gray-100 flex flex-col"
              >
                {/* Image with gradient overlay */}
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.imageAlt}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-br ${service.gradientFrom} ${service.gradientTo} opacity-60`} />
                  <div className="absolute inset-0 flex flex-col justify-end p-6">
                    <span className={`self-start text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-2 ${service.badgeBg} ${service.badgeText}`}>
                      Service {String(index + 1).padStart(2, "0")}
                    </span>
                    <h3 className="text-2xl font-bold text-white drop-shadow">
                      {service.title}
                    </h3>
                  </div>
                </div>

                {/* Content */}
                <div className="flex flex-col flex-1 p-7">
                  <p className="text-gray-500 mb-5 leading-relaxed text-sm">
                    {service.description}
                  </p>

                  {/* Feature list */}
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mb-7 flex-1">
                    {service.items.map((item) => (
                      <li key={item} className="flex items-center gap-2 text-gray-700 text-sm">
                        <svg
                          className={`w-4 h-4 flex-shrink-0 ${service.checkColor}`}
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <circle cx="8" cy="8" r="8" fill="currentColor" fillOpacity="0.12" />
                          <path
                            d="M5 8l2 2 4-4"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        {item}
                      </li>
                    ))}
                  </ul>

                  {/* CTA */}
                  <div className="pt-5 border-t border-gray-100">
                    <Link
                      to={service.link}
                      className={`inline-flex items-center gap-2 bg-gradient-to-r ${service.gradientFrom} ${service.gradientTo} text-white text-sm font-semibold py-3 px-7 rounded-xl hover:opacity-90 transition-all duration-200 shadow-md group/btn`}
                    >
                      View More
                      <svg
                        className="w-4 h-4 transition-transform duration-200 group-hover/btn:translate-x-1"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M3 8h10M9 4l4 4-4 4"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;

